const {
  EXPERIMENT_ENTITY_ID,
  LAST_DISCARDED_NOTIFICATION,
  LAST_READ_NOTIFICATION,
  MAIN,
  CONSENT,
  HEIMDALL,
  LOGIN_BETA,
  INSTALL_DISMISSED,
  TYPETAG_LEGACY,
  HEADER_INSTALL_CTA_DISMISSED,
  SEARCHES_AFTER_INSTALL,
  PRIVACY_CHOICE_TEST,
} = require('../../../common/js/constants/cookies');

const CONSENT_CATEGORIES = {
  essential: 'e',
  analytics: 'a',
  marketing: 'm',
  personalisation: 'p',
};

const COOKIES_LIST = [
  {
    name: CONSENT,
    description: 'Used to store cookie consent.',
    multipleValues: false,
    permission: CONSENT_CATEGORIES.essential,
  },
  {
    name: MAIN,
    description: 'Ecosia main cookie',
    sanitizer: 'ecosiaUser',
    multipleValues: true,
    permission: CONSENT_CATEGORIES.essential,
    permissions: {
      // if a cookie use multiple Value like the ECFG cookie, permissions can be set for each value
      addOn: CONSENT_CATEGORIES.essential,
      autoSuggestion: CONSENT_CATEGORIES.essential,
      customSettings: CONSENT_CATEGORIES.analytics,
      deviceType: CONSENT_CATEGORIES.essential,
      adultFilter: CONSENT_CATEGORIES.essential,
      firstRun: CONSENT_CATEGORIES.essential,
      firstSearch: CONSENT_CATEGORIES.analytics,
      language: CONSENT_CATEGORIES.essential,
      lastTreePlanted: CONSENT_CATEGORIES.essential,
      marketApplied: CONSENT_CATEGORIES.essential,
      notifications: CONSENT_CATEGORIES.essential,
      newTab: CONSENT_CATEGORIES.essential,
      personalizedSearch: CONSENT_CATEGORIES.personalisation,
      bingUserId: CONSENT_CATEGORIES.personalisation,
      treeCount: CONSENT_CATEGORIES.essential,
      typeTag: CONSENT_CATEGORIES.analytics,
      temperatureUnit: CONSENT_CATEGORIES.essential,
      windUnit: CONSENT_CATEGORIES.essential,
    },
  },
  {
    name: LAST_DISCARDED_NOTIFICATION,
    description: 'Saves the timestamps when banner or popup notification was discarded',
    multipleValues: false,
    permission: CONSENT_CATEGORIES.essential,
  },
  {
    name: LAST_READ_NOTIFICATION,
    description: 'Saves the timestamp when the notifications center or archive was last opened',
    multipleValues: false,
    permission: CONSENT_CATEGORIES.essential,
  },
  {
    name: INSTALL_DISMISSED,
    description: 'Saves whether the search install popup has been dismissed',
    multipleValues: false,
    permission: CONSENT_CATEGORIES.essential,
  },
  {
    name: HEIMDALL,
    description: 'Heimdall access token',
    multipleValues: false,
    permission: CONSENT_CATEGORIES.essential,
  },
  {
    name: EXPERIMENT_ENTITY_ID,
    description: 'Random generated user id for experiments',
    multipleValues: false,
    permission: CONSENT_CATEGORIES.essential,
  },
  {
    // TODO: The cookie name is very confusing and should be changed
    name: LOGIN_BETA,
    description: 'Used for identifiying previous logged in devices',
    multipleValues: false,
    permission: CONSENT_CATEGORIES.essential,
  },
  {
    name: TYPETAG_LEGACY,
    description: 'Stores the typetag (see Parameters used by Analytics).',
    multipleValues: false,
    permission: CONSENT_CATEGORIES.marketing,
  },
  {
    name: SEARCHES_AFTER_INSTALL,
    description: 'Tracks searches after the extension has been installed.',
    multipleValues: false,
    permission: CONSENT_CATEGORIES.analytics,
  },
  {
    name: PRIVACY_CHOICE_TEST,
    description: 'Used to determine whether the user should see the Privacy Choice callout.',
    multipleValues: false,
    permission: CONSENT_CATEGORIES.essential,
  },
  {
    name: HEADER_INSTALL_CTA_DISMISSED,
    description: 'Used to identify if the header cta has been dismissed.',
    multipleValues: false,
    permission: CONSENT_CATEGORIES.essential,
  },
  {
    name: 'ENPS',
    description: 'Net Promoter Score survey callout cookie.',
    multipleValues: false,
    permission: CONSENT_CATEGORIES.marketing,
  },
  {
    name: 'sp',
    description: 'Snowplow main cookie.',
    multipleValues: false,
    permission: CONSENT_CATEGORIES.analytics,
  },
  {
    name: 'ecosia_sp2id.3d5d',
    description: 'Snowplow user id.',
    multipleValues: false,
    permission: CONSENT_CATEGORIES.analytics,
  },
  {
    name: 'ecosia_sp2ses.3d5d',
    description: 'Snowplow ses cookie.',
    multipleValues: false,
    permission: CONSENT_CATEGORIES.analytics,
  },
];

module.exports = {
  COOKIES_LIST,
  CONSENT_CATEGORIES,
};
